import Dropdown from 'components/form/Dropdown'
import Label from 'components/form/Label'
import Card from 'components/Layout/Card'
import { useFormikContext } from 'formik'
import React from 'react'
import { useSelector } from 'react-redux'
import { icons } from 'utils/constants'

const ResearchInformation = ({ isView }) => {
    const reduxData = useSelector((state) => state.aiAbstractSubmission);
    const { aiAbstractData } = reduxData || {};
    const { values, handleChange, errors } = useFormikContext();

    return (
        <Card className='cp-20'>
            <div className="text-16-500 color-1717 cmb-20">
                Research Information
            </div>
            <div className="border-bottom cmb-20 color-d1d1"></div>
            <div>
                <div className="d-flex flex-wrap align-items-center gap-3">
                    <div className="flex-shrink-0">
                        <img
                            src={icons.AIPowered}
                            alt="AI Powered"
                            className="img-fluid"
                            style={{ maxWidth: "55px", height: "auto" }}
                        />
                    </div>
                    <div className="flex-grow-1">
                        <div className="text-20-500-25">
                            AI-Powered Research Mapping
                        </div>
                        <div className="14-400-18 color-black-olive mt-2">
                            Our AI has analyzed your research and suggests the following alignments:
                        </div>
                    </div>
                </div>
                <div className="row cmt-23">
                    <div className="col-12 cbt-8">
                        <Label label="Conference Track Match" className="text-14-400-18 color-black-olive" />
                    </div>

                    {/* Dropdown */}
                    <div className="col-12 col-md-6 mb-3 mb-md-0 ">
                        <Dropdown
                            id="conference_track"
                            placeholder="Select"
                            options={(aiAbstractData?.conference_track_match || [])?.map(item => ({
                                id: item,
                                label: item,
                            }))}
                            onChange={handleChange}
                            value={values?.conference_track}
                            error={errors?.conference_track}
                            disabled={isView}
                        />
                    </div>

                    {/* Confidence Box */}
                    <div className="col-12 col-md-6">
                        <div className="d-flex align-items-center justify-content-center text-16-500-20 color-a35b bg-effed " style={{ width: "184px", height: "40px" }}>
                            {values?.sdg_percentage}% Confidence
                        </div>
                    </div>
                </div>

                <div className="row cmt-23 ">
                    <div className="col-12 cbt-8">
                        <Label label="SDG Alignment" className="text-14-400-18 color-black-olive" />
                    </div>
                    <div className="col-12 col-md-6 mb-3 mb-md-0">
                        <div className='text-14-400-18 color-new-car bg-eff3 cps-14 cpe-14 cpt-10 cpb-10'>
                            {values?.sdg_name}
                        </div>
                    </div>
                    <div className="col-12 col-md-6">
                        <div className="d-flex align-items-center justify-content-center text-16-500-20 color-new-car bg-eff3" style={{ width: "100px", height: "38px" }}>
                            {values?.sdg_goals}
                        </div>
                    </div>
                </div>

                {!isView &&
                    <div className='cmt-23 text-14-300-18 '>
                        {values?.sdg_introduction}
                    </div>
                }
            </div>

        </Card>
    )
}

export default ResearchInformation
